import Vue from "vue"

const state = {
  items: []
}

const getters = {
  subTotal: state => state.items.reduce((total, item) => total + item.price * item.qty, 0),
  vat: (state, getters) => (getters.subTotal + getters.delivery) * 0.2,
  delivery: (state, getters, rootState) => {
    if (!getters.subTotal) return 0
    if (!rootState.settings) return 0
    if (!rootState.settings.cost) return 0
    if (!rootState.settings.free_threshold) return 0

    if (getters.subTotal >= rootState.settings.free_threshold) return 0
    return Number(rootState.settings.cost)
  },
  grandTotal: (state, getters) => getters.subTotal + getters.delivery + getters.vat
}

const mutations = {
  addItem: (state, payload) => {
    // Get index of matching product in basket
    var productIndex = state.items.findIndex(item => item.product.ItemID == payload.product.ItemID)

    // If product not already in basket
    if (productIndex == -1) state.items.push(payload)
    // else, product not already in basket, update qty
    else Vue.set(state.items[productIndex], "qty", state.items[productIndex].qty + payload.qty)
  },
  updateQty: (state, payload) => {
    if (payload.quantity > 0) state.items[payload.index].qty = Number(payload.quantity)
    else state.items.splice(payload.index, 1)
  },
  reOrder: (state, payload) => {
    state.items = payload.items
  },
  emptyCart: state => (state.items = [])
}

const actions = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
